// Lleva una seccion de la portada a la vista y la mantiene ahi.
//
// La portada mide ~11.000 px y sus imagenes cargan tarde, asi que calcular el
// destino una sola vez no sirve: se apunta a una posicion que deja de ser valida
// en cuanto el layout crece y el visitante acaba a 300 px del tope creyendo que
// el boton no hizo nada. Por eso se vigila un par de segundos, recalculando en
// cada pasada, y se deja de insistir cuando la seccion ya esta donde toca.
const DESPLAZAMIENTO = 80; // alto de la barra superior fija
const PASADAS = 10;
const INTERVALO = 250;

export const scrollToSection = (selector) => {
    let pasada = 0;
    const ir = () => {
        pasada += 1;
        const el = document.querySelector(selector);
        if (el) {
            const desfase = el.getBoundingClientRect().top - DESPLAZAMIENTO;
            if (Math.abs(desfase) > 4) {
                if (window.__lenis) window.__lenis.scrollTo(el, { offset: -DESPLAZAMIENTO });
                else el.scrollIntoView({ behavior: "smooth" });
            }
        }
        if (pasada < PASADAS) setTimeout(ir, INTERVALO);
    };
    ir();
};
